export enum LocaleToPkgEnum {
	us = 'AC',
	au = 'AUSIRET'
}
